import { ScheduleV0 } from '@provider-portal/common/api/gen/DeliveryProviderPortalAuthApi';
import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import { Nullable } from 'types/types';

import { getScheduleAsyncAction, ScheduleActions, updateScheduleAsyncAction } from './actions';

export interface ScheduleState {
  schedule: Nullable<ScheduleV0>;
  fetchingState: NetworkRequestState;
  error?: Error;
  updateRequestState: NetworkRequestState;
}

const initialState: ScheduleState = {
  schedule: null,
  fetchingState: NetworkRequestState.unset,
  updateRequestState: NetworkRequestState.unset,
};

export const scheduleReducer = (
  state: ScheduleState = initialState,
  action: ScheduleActions,
): ScheduleState => {
  switch (action.type) {
    case getType(getScheduleAsyncAction.request): {
      return {
        ...state,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(getScheduleAsyncAction.success): {
      return {
        ...state,
        schedule: action.payload.schedule,
        fetchingState: NetworkRequestState.success,
      };
    }
    case getType(getScheduleAsyncAction.failure): {
      return {
        ...state,
        fetchingState: NetworkRequestState.failure,
      };
    }

    case getType(updateScheduleAsyncAction.request): {
      return {
        ...state,
        updateRequestState: NetworkRequestState.waiting,
      };
    }
    case getType(updateScheduleAsyncAction.success): {
      return {
        ...state,
        updateRequestState: NetworkRequestState.success,
      };
    }
    case getType(updateScheduleAsyncAction.failure): {
      return {
        ...state,
        error: action.payload,
        updateRequestState: NetworkRequestState.failure,
      };
    }

    default: {
      return state;
    }
  }
};
